import { FC } from 'react';
import { Box, Grid, GridItem } from '@chakra-ui/react';

import { TextWithTooltip } from 'components/molecules/TextWithTooltip/TextWithTooltip';
import { CustomerForNotification } from 'types/customer';

type Props = {
  /** 顧客情報 */
  item: CustomerForNotification;
};

export const ReadonlyCustomerListItem: FC<Props> = ({ item }) => (
  <Box
    m={0}
    h="40px"
    w="100%"
    color="secondaryList.item.color"
    border="none"
    backgroundColor="secondaryList.item.bgColor"
    cursor="auto"
    _hover={{
      background: 'gray.100',
    }}
    _active={{
      background: 'gray.200',
    }}
    borderBottom="1px"
    borderBottomColor="secondaryList.item.borderColor"
  >
    <Grid
      h="100%"
      templateColumns="4fr 10fr 15fr"
      gap={0}
      justifyItems="start"
      alignItems="center"
    >
      <GridItem justifySelf="end" pr="20px">
        <TextWithTooltip text={item.id.toString()} />
      </GridItem>
      <GridItem pl="20px">
        <TextWithTooltip text={item.name} />
      </GridItem>
      <GridItem pl="20px">
        <TextWithTooltip
          text={item.detail}
          textMaxWidth="200px"
          visibleTooltip
          tooltipMaxWidth="300px"
        />
      </GridItem>
    </Grid>
  </Box>
);
